import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { ViewBrand } from 'src/app/model/Master/Brand/view-brand';
import { Floor } from 'src/app/model/Master/floor';
import { PageRequestParam } from 'src/app/model/Master/page-request-param';
import { ViewCity } from 'src/app/model/Master/City/view-city';
import { ViewComposition } from 'src/app/model/Master/Composition/view-composition';
import { ViewCustomerClass } from 'src/app/model/Master/CustomerClass/view-customer-class';
import { ViewJobRole } from 'src/app/model/Master/JobRole/view-job-role';
import { ViewSalesChannel } from 'src/app/model/Master/SalesChannel/view-sales-channel';
import { HandleError, HttpErrorHandlerService } from '../http-error-handler.service';
import { ViewProductBatch } from 'src/app/model/Master/ProductBatch/view-product-batch';
import { ViewDesignation } from 'src/app/model/Master/Designation/view-designation';
import { ViewCrate } from 'src/app/model/Master/Crate/view-crate';
import { ViewBank } from 'src/app/model/Master/Bank/view-bank';
import { ViewRegion } from 'src/app/model/Master/Region/view-region';
import { ViewArea } from 'src/app/model/Master/Area/view-area';
import { catchError } from 'rxjs/operators';
import { ViewProductDetail } from 'src/app/model/Master/Product/view-product-detail';
import { ViewServiceMan } from 'src/app/model/Master/ServiceMan/view-service-man';
import { ServiceMan } from 'src/app/model/Master/ServiceMan/service-man';
import { Route } from 'src/app/model/Master/Route/route';
import { SalesChannel } from 'src/app/model/Master/SalesChannel/sales-channel';
import { RequestView } from 'src/app/model/OrderManagement/OrderStock/RewMaterials/RequestView/request-view';
import { ProductionMachine } from 'src/app/model/Master/ProductionMachine/production-machine';
import { Internationalization } from 'src/app/model/Master/internationalization';
import { SubscriptionRedemptionRequest } from 'src/app/model/subscription-redemption-request';

@Injectable({
  providedIn: 'root'
})
export class MasterfunctionService {

  private handleError: HandleError;
  header: HttpHeaders | { [header: string]: string | string[]; };

  constructor(
    private http: HttpClient,
    private apiUrl: APIFactoryEndPoints,
    httpErrorHandle: HttpErrorHandlerService
  ) {
    this.handleError = httpErrorHandle.createHandleError('MastercontainerService');
  }

  insertProductionMachine(url: string, data: ProductionMachine) {
    return this.http.post(url, data)
  }
  updateProductionMachine(url: string, data: ProductionMachine) {
    return this.http.put(url, data)
  }

  //Company
  insertCompany(url: string, formGroup: UntypedFormGroup, file: File): Observable<any> {
    let formData = new FormData();
    formData.append('formData', new Blob([JSON.stringify(formGroup.value)], { type: 'application/json' }));
    formData.append('file', file);

    return this.http.post(
      url,
      formData,
      { responseType: 'json' })
  }
  updateCompany(url: string, formGroup: UntypedFormGroup, file: File): Observable<any> {
    let formData = new FormData();
    formData.append('formData', new Blob([JSON.stringify(formGroup.value)], { type: 'application/json' }));
    formData.append('file', file);

    return this.http.put(
      url,
      formData,
      { responseType: 'json' })
  }

  //ServiceMan
  insertServiceMan(url: string, obj: ServiceMan) {
    return this.http.post(url, obj)
  }
  viewServiceMan(url: string, obj: ViewServiceMan) {
    return this.http.post(url, obj);
  }
  // updateServiceMan(url: string, refNo: number, services: number) {
  //   return this.http.patch(url + "/" + refNo + "/" + services);
  // }

  //Product
  insertProduct(url: string, obj: UntypedFormGroup, file: File, thumbnailFiles: File[]): Observable<any> {
    let formData: any = new FormData();
    formData.append('formData', new Blob([JSON.stringify(obj.value)], { type: 'application/json' }));
    formData.append('file', file);
    if (thumbnailFiles) {
      thumbnailFiles.forEach(e => {
        formData.append('thumbnailFiles', e);
      })
    } else {
      formData.append('thumbnailFiles', null);
    }

    return this.http.post(
      url,
      formData,
      { responseType: 'json' })
  }
  viewProduct(url: string, obj: ViewProductDetail) {
    return this.http.post(url, obj);
  }
  updateProduct(url: string, obj: UntypedFormGroup, file: File, thumbnailFiles: File[]): Observable<any> {
    let formData = new FormData();
    formData.append('formData', new Blob([JSON.stringify(obj.value)], { type: 'application/json' }));
    formData.append('file', file);
    if (thumbnailFiles) {
      thumbnailFiles.forEach(e => {
        formData.append('thumbnailFiles', e);
      })
    } else {
      formData.append('thumbnailFiles', null);
    }

    return this.http.put(
      url,
      formData,
      { responseType: 'json' })
  }


  //Employee
  insertEmployee(url: string, obj: UntypedFormGroup, file: File): Observable<any> {
    let formData = new FormData();
    formData.append('formData', new Blob([JSON.stringify(obj.value)], { type: 'application/json' }));
    formData.append('file', file);

    return this.http.post(
      url,
      formData,
      { responseType: 'json' })
  }
  viewEmployee(url: string, requestView: RequestView) {
    return this.http.post(url, requestView);
  }
  updateEmployee(url: string, obj: UntypedFormGroup, file: File): Observable<any> {
    let formData = new FormData();
    formData.append('formData', new Blob([JSON.stringify(obj.value)], { type: 'application/json' }));
    formData.append('file', file);

    return this.http.post(
      url,
      formData,
      { responseType: 'json' })
  }

  //Department start
  insertDepartment(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value);
  }
  viewDepartment(url: string, pageRequestParam: PageRequestParam) {
    return this.http.post(url, pageRequestParam);
  }
  updateDepartment(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //Bank
  insertBank(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value);
  }
  viewBank(url: string, obj: ViewBank) {
    return this.http.post(url, obj);
  }
  updateBank(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //Crate
  insertCrate(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value);
  }
  viewCrate(url: string, obj: ViewCrate) {
    return this.http.post(url, obj);
  }
  updateCrate(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //Organiser Class Start
  insertOrganiserClass(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value);
  }
  viewOrganiserClass(url: string, pageRequestParam: PageRequestParam) {
    return this.http.post(url, pageRequestParam);
  }
  updateOrganiserClass(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //Designation
  insertDesignation(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value);
  }
  viewDesignation(url: string, obj: ViewDesignation) {
    return this.http.post(url, obj);
  }
  updateDesignation(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //ProductBatch
  insertProductBatch(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value);
  }
  viewProductBatch(url: string, obj: ViewProductBatch) {
    return this.http.post(url, obj);
  }
  updateProductBatch(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //Brand
  insertBrand(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value);
  }
  viewBrand(url: string, obj: ViewBrand) {
    return this.http.post(url, obj);
  }
  updateBrand(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //SalesChannel
  insertSalesChannel(url: string, obj: SalesChannel) {
    return this.http.post(url, obj);
  }
  viewSalesChannel(url: string, obj: ViewSalesChannel) {
    return this.http.post(url, obj);
  }
  updateSalesChannel(url: string, obj: SalesChannel) {
    return this.http.put(url, obj);
  }

  //JobRole
  insertJobRole(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value);
  }
  viewJobRole(url: string, obj: ViewJobRole) {
    return this.http.post(url, obj);
  }
  updateJobROle(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //CustomerClass
  insertCustomerClass(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value);
  }
  viewCustomerClass(url: string, obj: ViewCustomerClass) {
    return this.http.post(url, obj);
  }
  updateCustomerClass(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //floor start
  insertFloor(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value)
  }

  // insertFloor(url: string, formGroup: FormGroup) : Observable<any> {
  //   let headers = new HttpHeaders({
  //     'platform': 'Web'
  //   });
  //   return this.http.post<any>(url, formGroup.value,
  //     {
  //       headers: headers
  //     }
  //   );
  // }

  updateFloor(url: string, floor: UntypedFormGroup) {
    return this.http.put(url, floor.value);
  }


  //location type 
  addLocationType(url: string, form: UntypedFormGroup) {
    return this.http.post(url, form.value);
  }
  viewLocationType(url: string, obj: PageRequestParam) {
    return this.http.post(url, obj);
  }
  updateLocationType(url: string, loc: UntypedFormGroup) {
    return this.http.put(url, loc.value);
  }


  //Composition
  insertComposition(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value);
  }
  viewComposition(url: string, obj: ViewComposition) {
    return this.http.post(url, obj);
  }
  updateComposition(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //City
  insertCity(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value);
  }
  viewCity(url: string, obj: ViewCity): Observable<any> {
    return this.http.post(url, obj);
  }
  updateCity(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //Region
  insert(url: string, formGroup: UntypedFormGroup) {
    return this.http.post(url, formGroup.value)
  }
  view(url: string, obj: ViewRegion) {
    return this.http.post(url, obj);
  }
  update(url: string, formGroup: UntypedFormGroup) {
    return this.http.put(url, formGroup.value);
  }

  //Group
  insertGroup(url: string, obj: UntypedFormGroup, file: File): Observable<any> {
    let formData: any = new FormData();
    formData.append('formData', new Blob([JSON.stringify(obj.value)], { type: 'application/json' }));
    formData.append('file', file);

    return this.http.post(
      url,
      formData,
      { responseType: 'json' })
  }

  updateGroup(url: string, obj: UntypedFormGroup, file: File): Observable<any> {
    let formData = new FormData();
    formData.append('formData', new Blob([JSON.stringify(obj.value)], { type: 'application/json' }));
    formData.append('file', file);

    return this.http.put(
      url,
      formData,
      { responseType: 'json' })
  }

  //Route
  insertRoute(url: string, obj: Route) {
    return this.http.post(url, obj)
  }

  //organiser location 
  insertOrganiserLocation(url: string, form: UntypedFormGroup) {
    return this.http.post(url, form.value);
  }

  viewOrganiserLocation(url: string, req: PageRequestParam) {
    return this.http.post(url, req);
  }
  updateOrganiserLocation(url: string, form: UntypedFormGroup) {
    return this.http.put(url, form.value);
  }


  //Customer
  insertCustomer(url: string, obj: UntypedFormGroup): Observable<any> {
    return this.http.post<string>(url, obj.value)
    // .pipe(
    //   catchError(this.handleError('insertCustomer', 'I am an error')
    //   ));
  }
  updateCustomer(url: string, formGroup: UntypedFormGroup) {
    return this.http.patch(url, formGroup.value);
  }

  //import
  postImportedFileDetails(url: string, doc: File): Observable<any> {
    let formData = new FormData();
    formData.append('file', doc);

    return this.http.post(url,
      formData,
      { responseType: 'json' })
  }

  importSalesChannel(url: string, locId: number, obj: SalesChannel[]) {
    // let formData = new FormData();
    // formData.append('file', doc);

    return this.http.post(url + "/" + locId, obj);
  }

  postImportedFileDetailsWithLocId(url: string, locId: number, doc: File): Observable<any> {
    let formData = new FormData();
    formData.append('file', doc);

    return this.http.post(url + "/" + locId,
      formData,
      { responseType: 'json' })
  }


  postImportedImageFileDetails(url: string, doc: File): Observable<any> {
    let formData = new FormData();
    formData.append('file', doc);

    return this.http.post(url, formData,
      { responseType: 'json' })
  }
  insertInternationalization(url: string,type: string ,obj: Internationalization) {
    return this.http.post(url+"/"+type, obj);
  }
  insertInternationalizationByusingForm(url: string, type: string, formGroup: UntypedFormGroup) {
    return this.http.post(url + "/" + type, formGroup.value);
  }

  insertSubscriptionRedemption(url: string, subscriptionRedemptionRequest: SubscriptionRedemptionRequest) {
    return this.http.post(url, subscriptionRedemptionRequest)
  }
}

